import React from 'react';
import { useAuth } from '@/context/AuthContext';
import { UserPermissions } from '@/types/auth';

interface PermissionGuardProps {
  module: keyof UserPermissions;
  action?: string;
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Conditionally renders children if the authenticated user has the specified module/action permission.
 * Admins have unrestricted access across all modules.
 */
export const PermissionGuard: React.FC<PermissionGuardProps> = ({
  module,
  action = 'view',
  fallback = null,
  children,
}) => {
  const { hasPermission } = useAuth();

  if (!hasPermission(module, action)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
